import styled, { css } from 'styled-components';

const SliderWrapper = styled.div<{ disabled?: boolean }>`
  position: relative;
  width: 100%;
  margin-right: 10px;

  ${(props) =>
    props.disabled &&
    css`
      display: none;
    `};
`;

export default SliderWrapper;
